export default [
	{
		path: "/404page",
		name: "error.404page",
		component: () => import("@/resources/error/404page"),
	},
	{
		path: "/maintain",
		name: "error.maintain",
		component: () => import("@/resources/error/maintainpage"),
	},
];
